const initialState = {
  selectedMask: null,
  isOpen: false
};

export const maskSelectorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_MASK_SELECTOR": {
      return initialState;
    }
    case "SET_MASK_SELECTOR": {
      return { ...state, ...action.maskSelector };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mask-selector.js